<template>
  <div class="flex flex-1 gap-x-2 md:gap-x-6">
    <!-- {{ data }} -->
    <!-- {{ productData }} -->

    <div
      :class="
        twJoin(
          'w-16 md:w-[130px] h-16 md:h-[130px] bg-primary-white rounded-lg overflow-hidden',
          (isOutOfStock || isStickerOutOfStock) && 'opacity-60'
        )
      "
    >
      <SkeletonLoader v-if="isLoading" class="w-full h-full" />
      <img
        v-if="
          data.personalization_base64 || data?.personalization?.thumbnail_base64
        "
        alt=""
        :src="
          data.personalization_base64 || data?.personalization?.thumbnail_base64
        "
        :class="twJoin('w-full h-full object-contain md:py-4 py-2')"
      />
      <img
        v-else-if="productData?.thumbnailUrl && !data.metadata"
        alt=""
        class="object-contain w-full h-full"
        :src="config.public.mediaUrl + productData?.thumbnailUrl"
      />
    </div>
    <SkeletonLoader v-if="isLoading" class="flex flex-1" />
    <div v-else class="flex flex-1">
      <div
        :class="
          twJoin(
            'flex-1',
            (isOutOfStock || isStickerOutOfStock) && 'opacity-60'
          )
        "
      >
        <NuxtLinkLocale
          :to="
            data?.personalization
              ? data?.personalization?.shared_url
              : itemSlug?.artworkSlug
                ? `/product/${itemSlug?.productSlug}/${itemSlug?.artworkSlug}`
                : `/product/${itemSlug?.productSlug}`
          "
          :class="{
            'pointer-events-none': props.data.details?.open_for_sale == 0
          }"
          @click="closeCart"
        >
          <div class="font-bold mb-2 md:mb-[10px]">
            <span v-if="props.data?.personalization">Personalized Case</span>
            <span v-else>
              {{ productData?.artworkName || productData?.productName }}
            </span>
          </div>
        </NuxtLinkLocale>

        <div>
          <div
            v-for="(item, index) in orderBy(
              productDetail?.product_option_product?.filter(
                (item) =>
                  !item?.option_id?.product_option_group_id?.name_en?.includes(
                    'Brand'
                  )
              ),
              (item) => item?.option_id?.id,
              'asc'
            ).reduce(
              (unique, current) => {
                const isDuplicate = unique.some(
                  (item: any) =>
                    item?.option_id?.product_option_group_id?.name_en ===
                    current?.option_id?.product_option_group_id?.name_en
                )
                if (!isDuplicate) {
                  unique.push(current as any)
                }
                return unique
              },
              [] as GetProductDetailResponse['data']['product_option_product']
            )"
            :key="index"
            class="text-sm md:tex-sm"
          >
            <div
              v-if="
                item?.option_id?.name_th ||
                (item?.option_id?.name_en && item?.option_id?.name_th) ||
                item?.option_id?.name_en
              "
            >
              <span class="font-bold"
                >{{
                  locale === 'en'
                    ? item?.option_id?.product_option_group_id?.name_en
                    : item?.option_id?.product_option_group_id?.name_th ||
                      item?.option_id?.product_option_group_id?.name_en
                }}:</span
              >
              {{
                locale === 'en'
                  ? item?.option_id?.name_en
                  : item?.option_id?.name_th || item?.option_id?.name_en
              }}
            </div>
          </div>
          <div
            v-if="productDetail?.product_variable?.type"
            class="text-sm md:text-sm"
          >
            <span class="font-bold">{{ $t('cart.type') }}:</span>
            {{
              locale === 'en'
                ? productDetail?.product_variable?.display_name_en
                : productDetail?.product_variable?.display_name_th ||
                  productDetail?.product_variable?.display_name_en
            }}
          </div>
          <div
            v-else-if="productData?.artworkName && productData?.productName"
            class="text-sm md:text-sm"
          >
            <span class="font-bold">{{ $t('cart.type') }}:</span>
            {{ productData?.productName }}
          </div>
        </div>
        <div class="mt-2 font-bold md:hidden">
          {{
            displayCommaNumber((productData?.price || 0) * data?.quantity, 2)
          }}
          THB
        </div>
        <div
          v-if="
            data.details?.open_for_sale === 0 ||
            data.details?.artwork_open_for_sale === 0 ||
            data.details?.artwork_product_open_for_sale === 0 ||
            data.details?.product_open_for_sale === 0
          "
          class="max-w-[250px] mx-auto px-4 py-1 mt-5 font-bold text-white bg-black rounded-2xl break-words leading-normal text-sm text-center"
        >
          {{
            data.details?.open_for_sale === 0
              ? locale === 'en'
                ? data.details['open_for_sale_message_en'] ||
                  $t('cart.openForSale')
                : locale === 'th'
                  ? data.details['open_for_sale_message_th'] ||
                    $t('cart.openForSale')
                  : $t('cart.openForSale')
              : data.details?.product_open_for_sale === 0
                ? locale === 'en'
                  ? data.details['product_open_for_sale_message_en'] ||
                    $t('cart.openForSale')
                  : locale === 'th'
                    ? data.details['product_open_for_sale_message_th'] ||
                      $t('cart.openForSale')
                    : $t('cart.openForSale')
                : data.details?.artwork_open_for_sale === 0
                  ? locale === 'en'
                    ? data.details['artwork_open_for_sale_message_en'] ||
                      $t('cart.openForSale')
                    : locale === 'th'
                      ? data.details['artwork_open_for_sale_message_th'] ||
                        $t('cart.openForSale')
                      : $t('cart.openForSale')
                  : data.details?.artwork_product_open_for_sale === 0
                    ? locale === 'en'
                      ? data.details[
                          'artwork_product_open_for_sale_message_en'
                        ] || $t('cart.openForSale')
                      : locale === 'th'
                        ? data.details[
                            'artwork_product_open_for_sale_message_th'
                          ] || $t('cart.openForSale')
                        : $t('cart.openForSale')
                    : $t('cart.openForSale')
          }}
        </div>
        <div
          v-else-if="isStickerOutOfStock || isOutOfStock"
          class="px-4 py-1 mt-5 font-bold text-white bg-black rounded-2xl md:max-w-[60%] sm:w-full"
        >
          {{ $t('cart.productUnavailable') }}
        </div>
      </div>
      <div class="flex flex-col items-end justify-between">
        <div
          class="h-10 bg-primary-white flex flex-row justify-center items-center rounded-full px-[10px] font-bold select-none"
        >
          <!-- icon -->
          <!-- flow open_for_sale status 0 -->
          <div
            v-if="data.details?.open_for_sale == 0"
            class="flex items-center justify-center w-8 h-8 cursor-pointer"
            @click="
              () => {
                data?.quantity === 1 && emit('delete')
                handleDecreaseQuantity(data?.cartItemId, data.quantity)
              }
            "
          >
            <Icon v-if="data.details?.open_for_sale == 0" name="trash" />
          </div>
          <!-- flow open_for_sale status 0 -->

          <div
            v-if="data.details?.open_for_sale == 1"
            class="flex items-center justify-center w-8 h-8 cursor-pointer"
            @click="
              () => {
                data?.quantity === 1 && emit('delete')
                handleDecreaseQuantity(data?.cartItemId, data.quantity)
              }
            "
          >
            <Icon v-if="data?.quantity == 1" name="trash" />
            <Icon v-if="data?.quantity > 1" name="minus" />
          </div>
          <div
            v-if="data.details?.open_for_sale == 1"
            class="flex items-center justify-center w-8 h-8"
          >
            {{ data?.quantity }}
          </div>
          <div
            v-if="data.details?.open_for_sale == 1"
            :class="
              twJoin(
                'w-8 h-8 flex items-center justify-center cursor-pointer',
                productStocks &&
                  data?.quantity + 1 <= productStocks?.stocks &&
                  !isStickerOutOfStock &&
                  !isOutOfStock
                  ? 'opacity-100'
                  : 'opacity-50 pointer-events-none'
              )
            "
            @click="() => handleIncreaseQuantity(data.cartItemId)"
          >
            <Icon name="plus" />
          </div>
        </div>

        <!-- สิ้นสุด icon -->
        <div class="hidden font-bold md:block">
          {{
            displayCommaNumber((productData?.price || 0) * data?.quantity, 2)
          }}
          THB
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
import { find, orderBy, some, toNumber } from 'lodash-es'
import { productRepository } from '~/repository/productRepository'
import type { GetProductDetailResponse } from '~/types/apis/v2/getProductDetail'
import { personalizationRepository } from '~/repository/v2/personalizationRepository'

const config = useRuntimeConfig()

const props = defineProps<{
  data: CartStateV2['items'][number]
  deviceList: GetDeviceAllResponse['data']
  (e: 'loadeds', payload: GetProductDetailResponse): void
}>()

const emit = defineEmits(['loaded', 'delete', 'loadeds'])
const isOutOfStock = ref<boolean | undefined>()
const isStickerOutOfStock = ref<boolean | undefined>()

const { closeCart } = useWebsiteStoreV2()
const cartStore = useCartStoreV2()
const { itemsData, items } = storeToRefs(cartStore)
const {
  handleDecreaseQuantity: handleCartStoreDecreaseQuantity,
  handleIncreaseQuantity,
  handleSetQuantity,
  removeFromCart,
  updateProductData
} = useCartStoreV2()
const { on } = useEventTracking()
const { locale } = useI18n()

const isLoading = ref(true)
const productData = computed(() =>
  find(itemsData.value, (item) => item.cartItemId === props.data.cartItemId)
)
const productDetail = ref<GetProductDetailResponse['data']>()

const handleDecreaseQuantity = (cartItemId: string, quantity: number) => {
  const product = find(
    itemsData.value,
    (item) => item.cartItemId === props.data.cartItemId
  )
  if (product)
    on('remove_from_cart', {
      item_name: product.productName,
      item_id: product.artworkSku
        ? `${product.productSku}${product.artworkSku}`
        : product.productSku,
      quantity: quantity
    })
  handleCartStoreDecreaseQuantity(cartItemId)
}
const itemSlug = computed(() =>
  find(items.value, (item) => item.cartItemId === props.data.cartItemId)
)
const isStockLoading = ref(true)
const productStocks = ref<
  GetProductAvailableStocksResponse['data'][number] | null
>()
const { $api } = useNuxtApp()
const productRepo = productRepository($api)
const personalizationRepo = personalizationRepository($api)

const handleCheckProductStock = async () => {
  await productRepo
    .getProductStock({
      body: {
        itec_skus: productData.value?.productSku
          ? [productData.value?.productSku]
          : []
      },
      onResponse: ({ response }) => {
        productStocks.value = response._data.data?.[0]
        if (response._data.data?.[0].stocks < 1) {
          isOutOfStock.value = true
          emit('delete')
        } else if (response._data.data?.[0].stocks < props.data.quantity) {
          handleSetQuantity(
            props.data.cartItemId,
            response._data.data?.[0].stocks
          )
          isOutOfStock.value = false
        } else {
          isOutOfStock.value = false
        }
      }
    })
    .catch((error) => console.log(error))
  isStockLoading.value = false
}
const handleCheckAvailableSticker = async () => {
  try {
    await personalizationRepo.getFullPersonalizationDetail(
      props?.data?.productSlug,
      {
        onResponse: async ({ response }) => {
          if (response.status === 200) {
            let result = false
            for await (const sticker of props?.data?.personalization
              ?.stickers || []) {
              if (
                !some(
                  response?._data?.data?.full_personalization_template
                    ?.full_personalization_template_sticker,
                  (item) => item.sticker_image_url === sticker.image
                )
              ) {
                emit('delete')
                result = true
              }
            }
            isStickerOutOfStock.value = result
          }
        }
      }
    )
  } catch (error) {
    console.log(error)
  }
}

onMounted(async () => {
  const params = props.data.artworkSlug
    ? `${props.data.productSlug}/${props.data.artworkSlug}`
    : `${props.data.productSlug}`
  await useQuery<GetProductDetailResponse>(
    () => `/v2/storefront/product/${params}/product-detail`,
    {
      method: 'GET',
      onResponse: ({ response }) => {
        const data = response._data.data
        if (!data) {
          removeFromCart(props.data.cartItemId)
        }
        emit('loadeds', data)
        isLoading.value = false
        const payload = {
          cartItemId: props.data.cartItemId,
          variantName:
            locale.value === 'en'
              ? data?.product_variable?.display_name_en
              : data?.product_variable?.display_name_th ||
                data?.product_variable?.display_name_en,
          productName:
            locale.value === 'en'
              ? data?.product_name_en || data?.display_name_en
              : data?.product_name_th?.trim() ||
                data?.product_name_en ||
                data?.display_name_th ||
                data?.display_name_en,
          artworkName:
            locale.value === 'en'
              ? data.artwork_name_en
              : data.artwork_name_th?.trim() || data.artwork_name_en,
          productSku: data?.sku,
          artworkSku: data?.artwork_slug,
          thumbnailUrl: data?.thumbnail_image_url,
          price: toNumber(data?.price_data?.srp_price || '0'),
          productOptionProduct: data?.product_option_product,
          productVariable: data?.product_variable
        }
        productDetail.value = response._data.data
        updateProductData(payload)
        handleCheckProductStock()
        props?.data?.personalization && handleCheckAvailableSticker()
      }
    }
  )
})
watch(
  [isLoading, isStockLoading, isOutOfStock, isStickerOutOfStock],
  (nextValue) => {
    const loaded = !nextValue.some((v) => v === true)
    if (loaded) {
      emit('loaded')
    }
  }
)
</script>
